import {PageLayout} from '~/components'
import {Placeholder} from '../placeholder'
import {AggregatesHeader} from '../aggregates_header'
import {Graph} from '../graph'
import {useState} from 'react'
import {useGraphData} from './use_graph_data'

export const DashboardPage = ({graphVariantsTaxonomy, name}) => {
	const graphs = useGraphData({dataType: name, graphVariantsTaxonomy})
	if (_.isEmpty(graphs)) return <Placeholder name={name} />
	return <Inner graphs={graphs} name={name} graphVariantsTaxonomy={graphVariantsTaxonomy} />
}

const Inner = ({graphs, name, graphVariantsTaxonomy}) => {
	const seriesPointCount = _.first(graphs).data.length
	const [selectedSeriesPointIndex, setSelectedSeriesPointIndex] = useState(seriesPointCount - 1) // in the aggregates we want to default to showing the current month

	return (
		<PageLayout
			name={name}
			state={{
				selectedSeriesPointIndex,
				setSelectedSeriesPointIndex,
				graphVariantsTaxonomy,
				graphs,
			}}
			bodyLayoutProps={{width: 1000, padding: '24 0', gap: 8}}
		>
			<AggregatesHeader />
			<Graph />
		</PageLayout>
	)
}
